import { DashboardFilters, list } from './calls';

export default class DashboardAPICaller {
  static list = async (filters: DashboardFilters) => {
    const {
      data: { dashboardData },
    } = await list(filters);

    return dashboardData;
  };
}
